"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgRoadFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M11 7.5h2V3h1.733c1.029 0 1.925.703 2.175 1.704l4.058 14.898A1.126 1.126 0 0119.88 21H13v-4.5h-2V21H4.121a1.125 1.125 0 01-1.087-1.398L7.092 4.704A2.243 2.243 0 019.267 3H11v4.5zm2 2.25h-2v4.5h2v-4.5z' }))); };
exports.default = SvgRoadFilled;
//# sourceMappingURL=RoadFilled.js.map